import React, { useEffect } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { ProblemSection } from './components/ProblemSection';
import { ThreePhases } from './components/ThreePhases';
import { WhatsInside } from './components/WhatsInside';
import { ProductCard } from './components/ProductCard';
import { AuthorSection } from './components/AuthorSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { initMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark text-brand-cream selection:bg-brand-gold/30 selection:text-brand-cream" data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <TestimonialCarousel data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <ThreePhases data-id="element-6" />
      <WhatsInside data-id="element-7" />
      <ProductCard data-id="element-8" />
      <AuthorSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FaqSection data-id="element-11" />
      <FinalCta data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}